export enum TypeUser {
  AUTHORIZED = 'AUTHORIZED',
  RESPONSIBLE = 'RESPONSIBLE'
}
